export const recipes = [
  {
    id: 1,
    courseId: 1,
    name: "Klasični Beli Hleb",
    ingredients: [
      { name: "Brašno tip 500", amount: 500, unit: "g" },
      { name: "Voda", amount: 320, unit: "ml" },
      { name: "Kvasac", amount: 7, unit: "g" },
      { name: "So", amount: 10, unit: "g" },
      { name: "Šećer", amount: 5, unit: "g" },
      { name: "Maslac", amount: 15, unit: "g" }
    ],
    steps: [
      "Rastvorite kvasac u toploj vodi sa šećerom i pustite 10 minuta",
      "Pomešajte brašno sa solju u velikoj posudi",
      "Dodajte razapan kvasac i mešajte 8-10 minuta",
      "Dodajte maslac i nastavite sa mešanjem još 5 minuta",
      "Ostavite da se diže 1.5 sat na toplom mestu",
      "Oblikujte testo u lepo oblika na brašnom",
      "Ostavite da se diže još 45 minuta",
      "Pecite na 220°C sa parom 35-40 minuta do zlatne boje"
    ]
  },
  {
    id: 2,
    courseId: 2,
    name: "Kiflice od Kvasca sa Sirom",
    ingredients: [
      { name: "Brašno", amount: 400, unit: "g" },
      { name: "Mleko", amount: 180, unit: "ml" },
      { name: "Kvasac", amount: 5, unit: "g" },
      { name: "Sir", amount: 150, unit: "g" },
      { name: "Maslac", amount: 60, unit: "g" },
      { name: "Jaje", amount: 1, unit: "kom" },
      { name: "So", amount: 5, unit: "g" },
      { name: "Šećer", amount: 2, unit: "g" }
    ],
    steps: [
      "Zagrejte mleko do 40°C i pomešajte sa kvascem i šećerom",
      "Sipajte mlečnu smesu u brašno sa solju",
      "Mešajte 10 minuta dok se testo ne ujedini",
      "Dodajte omekšan maslac i mešajte još 5 minuta",
      "Ostavite testo da se diže 1 sat",
      "Razvaljajte testo 5mm debljine",
      "Rasporedite seckani sir po površini",
      "Savijte i naserite na komade od 5cm",
      "Ostavite da se diže još 30 minuta",
      "Premažite sa obranim jajetom",
      "Pecite 20 minuta na 200°C do zlatne boje"
    ]
  },
  {
    id: 3,
    courseId: 3,
    name: "Srpska Pogača",
    ingredients: [
      { name: "Brašno", amount: 500, unit: "g" },
      { name: "Voda", amount: 280, unit: "ml" },
      { name: "Kvasac", amount: 5, unit: "g" },
      { name: "So", amount: 10, unit: "g" },
      { name: "Maslac", amount: 100, unit: "g" },
      { name: "Jaje", amount: 1, unit: "kom" },
      { name: "Brašno za prhanje", amount: 50, unit: "g" }
    ],
    steps: [
      "Pomešajte brašno sa solju u velikoj posudi",
      "Razapite kvasac sa toplom vodom i dodajte jaje",
      "Sipajte u brašno i mešajte 12 minuta",
      "Dodajte omekšan maslac i mešajte do glatkoće",
      "Ostavite da se diže 1.5 sat u toploj sredini",
      "Prebacite na prhanjem brašno i oblikujte",
      "Prsti malo da ostanu vidljivi na pogači",
      "Ostavite 30 minuta na blatu",
      "Premažite ostatkom maslaca",
      "Pecite na 210°C 35-40 minuta do zlatne boje"
    ]
  },
  {
    id: 4,
    courseId: 4,
    name: "Čokoladne Kiflice",
    ingredients: [
      { name: "Brašno", amount: 350, unit: "g" },
      { name: "Mleko", amount: 150, unit: "ml" },
      { name: "Kvasac", amount: 5, unit: "g" },
      { name: "Maslac", amount: 80, unit: "g" },
      { name: "Šećer", amount: 30, unit: "g" },
      { name: "Kakao prah", amount: 30, unit: "g" },
      { name: "Jaje", amount: 2, unit: "kom" },
      { name: "So", amount: 3, unit: "g" },
      { name: "Vanila", amount: 1, unit: "ml" }
    ],
    steps: [
      "Zagrejte mleko i pomešajte sa kvascem i 1 šoljom šećera",
      "Dodajte jaje i vanilu",
      "Pomešajte brašno sa solju",
      "Sipajte mlečnu smesu u brašno i mešajte 10 minuta",
      "Dodajte omekšan maslac i mešajte 5 minuta",
      "Ostavite da se diže 1.5 sat",
      "Razvaljajte testo 3mm debljine",
      "Pomešajte kakao sa 20g šećera",
      "Rasporedite kakao smesu po testu",
      "Namotajte testo i sesite na komade",
      "Oblikujte u kiflice",
      "Ostavite da se diže 45 minuta",
      "Pecite 18-20 minuta na 190°C"
    ]
  },
  {
    id: 5,
    courseId: 5,
    name: "Medena Baklava",
    ingredients: [
      { name: "Filo brašno", amount: 400, unit: "g" },
      { name: "Maslac", amount: 150, unit: "g" },
      { name: "Oraščići", amount: 250, unit: "g" },
      { name: "Šećer", amount: 100, unit: "g" },
      { name: "Med", amount: 100, unit: "g" },
      { name: "Voda", amount: 50, unit: "ml" },
      { name: "Cimet", amount: 5, unit: "g" },
      { name: "Karanfil", amount: 3, unit: "kom" },
      { name: "Vanila", amount: 1, unit: "ml" },
      { name: "Limunski sok", amount: 15, unit: "ml" }
    ],
    steps: [
      "Sitno seckajte oraščiće i pomešajte sa cimetom i karanfilima",
      "Otopite maslac na blagoj temperaturi",
      "Razvaljajte filo list i premažite sa maslacima",
      "Rasprostrite tanko prvi filo list u oblastom premazanog tepsija",
      "Ponovite sa još 2-3 lista premažući sa maslacima",
      "Rasporedite tanko orašče smesu",
      "Dodajte još 3-4 lista filo sa maslacima",
      "Ponovite slojeve oraščića i filo 3 puta",
      "Naserite baklavu sa oštrom nožem u dijagonalne komade",
      "Pecite na 180°C 30-35 minuta do zlatne boje",
      "Pomešajte med, vodu, šećer i limunski sok",
      "Zagrejte sirup dok ne počne da ključa",
      "Sipajte topao sirup po toploj baklavi",
      "Pustite da se ohladi 2 sata pre nego što servira"
    ]
  }
];
